import React, { Fragment } from 'react'

const About = () => {
    return (
        <Fragment>
        <div>
            <h1>About</h1>
            <p>App for finding Github Users</p>
            <p>Version 1.0.0</p>
        </div>
        </Fragment>
    )
}

export default About